import React, { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { PatientState } from "../../data/atoms";
import { BalloonPopperScore } from "../../models/reports";
import { IonCol, IonGrid, IonRow } from "@ionic/react";
import TrendlineGraph from "../Graphs/TrendlineGraph";
import { TestType } from "../../models/Enums";
import TrendLineGraphSvg from "../Graphs/TrendLineGraphSvg";

interface Props {
  score: BalloonPopperScore;
}

const BalloonPopper_Test: React.FC<Props> = ({ score }) => {
  const patientInfo = useRecoilValue(PatientState);

  const [graphDetails, setGraphDetails] = useState<any>({
    lineGraphValues: [],
    RangeIds: [],
    TestType: TestType.hec_training,
    graphSvg: null,
  });

  const formatNumber = (value: number): string => {
    return Number.isInteger(value) ? value.toString() : value.toFixed(2);
  };

  useEffect(() => {
    console.log("BalloonPopper_Test score:", score);
    console.log("Patient Info:", patientInfo);

    let rangeIds: string[] = [];
    let currentTime = 0;

    if (score.settings.reachDirection === "BOTH") {
      score.settings.reachDirection = "Across, Outward";
    } else if (score.settings.reachDirection === "ACROSS_ONLY") {
      score.settings.reachDirection = "Across Only";
    } else if (score.settings.reachDirection === "OUTWARD_ONLY") {
      score.settings.reachDirection = "Outward Only";
    }

    if (score.settings.armMode === "BOTH") {
      score.settings.armMode = "Both";
    } else if (score.settings.armMode === "LEFT_ONLY") {
      score.settings.armMode = "Left Only";
    } else if (score.settings.armMode === "RIGHT_ONLY") {
      score.settings.armMode = "Right Only";
    }

    const timesArray = score.averageTimeToHitTrend[0];
    console.log("Times Array:", timesArray);

    timesArray?.forEach(() => {
      rangeIds.push(currentTime.toString());
      currentTime += 5;
    });

    setGraphDetails({
      lineGraphValues: timesArray,
      RangeIds: rangeIds,
      TestType: TestType.hec_training,
      graphSvg: null,
    });
  }, [score]);

  return (
    <IonGrid placeholder={undefined}>
      <IonRow placeholder={undefined}>
        <IonCol placeholder={undefined}>
          {graphDetails.RangeIds?.length > 0 ? (
            <div className="cutom-graph-wrap ap-graph-wrap">
              <div className="cutom-graph-wrap-header">
                <div className="left-sec">
                  <div className="svg-icon">
                    {/* <TrendLineGraphSvg
                      testLookupId={TestType.gait}
                      metricFilter={0}
                    ></TrendLineGraphSvg> */}
                    <svg
                      width="41"
                      height="42"
                      viewBox="0 0 41 42"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g filter="url(#filter0_d_12696_6793)">
                        <path
                          d="M33.9473 17.5C33.9473 24.9566 27.9271 31 20.4991 31C13.071 31 7.05078 24.9566 7.05078 17.5C7.05078 10.0434 13.071 4 20.4991 4C27.9271 4 33.9473 10.0434 33.9473 17.5ZM22.1801 9.0625C22.1801 8.1291 21.4289 7.375 20.4991 7.375C19.5692 7.375 18.818 8.1291 18.818 9.0625C18.818 9.9959 19.5692 10.75 20.4991 10.75C21.4289 10.75 22.1801 9.9959 22.1801 9.0625ZM20.4991 25.9375C22.3534 25.9375 23.8611 24.424 23.8611 22.5625C23.8611 21.6449 23.4987 20.817 22.9103 20.2105L26.2776 12.5271C26.556 11.8891 26.2671 11.1402 25.6315 10.8607C24.9958 10.5813 24.2499 10.8713 23.9714 11.5094L20.5989 19.1875C20.5673 19.1875 20.5306 19.1875 20.4991 19.1875C18.6447 19.1875 17.137 20.701 17.137 22.5625C17.137 24.424 18.6447 25.9375 20.4991 25.9375ZM16.2965 11.5938C16.2965 10.6604 15.5453 9.90625 14.6154 9.90625C13.6856 9.90625 12.9344 10.6604 12.9344 11.5938C12.9344 12.5271 13.6856 13.2812 14.6154 13.2812C15.5453 13.2812 16.2965 12.5271 16.2965 11.5938ZM12.0939 19.1875C13.0237 19.1875 13.7749 18.4334 13.7749 17.5C13.7749 16.5666 13.0237 15.8125 12.0939 15.8125C11.1641 15.8125 10.4129 16.5666 10.4129 17.5C10.4129 18.4334 11.1641 19.1875 12.0939 19.1875ZM30.5853 17.5C30.5853 16.5666 29.8341 15.8125 28.9042 15.8125C27.9744 15.8125 27.2232 16.5666 27.2232 17.5C27.2232 18.4334 27.9744 19.1875 28.9042 19.1875C29.8341 19.1875 30.5853 18.4334 30.5853 17.5Z"
                          fill="black"
                        />
                      </g>
                      <defs>
                        <filter
                          id="filter0_d_12696_6793"
                          x="0.104673"
                          y="0.526946"
                          width="40.7907"
                          height="40.8922"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="3.47305" />
                          <feGaussianBlur stdDeviation="3.47305" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_12696_6793"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_12696_6793"
                            result="shape"
                          />
                        </filter>
                      </defs>
                    </svg>
                  </div>
                  <div className="text-area">
                    <h6 className="mb-0">Trend of Avg Time to Hit (s)</h6>
                  </div>
                </div>
              </div>
              {/* <div className="text-area ">
                <h6 className="mb-0 slate-gray text-right"></h6>
              </div> */}
              <TrendlineGraph
                graphDetails={graphDetails}
                setSelectedIndex={() => {}}
                setIsGraphClicked={() => {}}
                circleClicked={() => {}}
                yMappings={null}
                allowNegative={true}
                isReportGraph={true}
              ></TrendlineGraph>
            </div>
          ) : (
            <></>
          )}

          <div className="table-heading-wrap">
            <h3>Performance Summary</h3>
            <div className="assessment-info-new-table training-table af-bp-table-cols table first-table">
              <table
                className="table two-col table-col-{{ table.Columns.length }} table-border-0"
                aria-describedby="Assessment-Info-Table"
              >
                <thead className="table-head">
                  <tr>
                    <th scope="col" className="fz-16 fw-700 text-left">
                      Measure
                    </th>
                    <th scope="col" className="fz-16 fw-700">
                      Value
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="fz-14 fw-600 text-left">
                      <span>Score per Minute</span>
                    </td>
                    <td className="fz-14 fw-600">
                      <span>
                        {!isNaN(score.scorePerMinute)
                          ? formatNumber(score.scorePerMinute)
                          : "-"}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td className="fz-14 fw-600 text-left">
                      <span>Balloons Hit per Minute</span>
                    </td>
                    <td className="fz-14 fw-600">
                      <span>
                        {!isNaN(score.balloonsHitPerMinute)
                          ? formatNumber(score.balloonsHitPerMinute)
                          : "-"}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td className="fz-14 fw-600 text-left">
                      <span>Balloons Missed per Minute</span>
                    </td>
                    <td className="fz-14 fw-600">
                      <span>
                        {!isNaN(score.balloonsMissedPerMinute)
                          ? formatNumber(score.balloonsMissedPerMinute)
                          : "-"}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td className="fz-14 fw-600 text-left">
                      <span>Average Time to Hit</span>
                    </td>
                    <td className="fz-14 fw-600">
                      <span>
                        {score.averageTimeToHit &&
                        score.averageTimeToHit != "undefined" &&
                        score.averageTimeToHit != null
                          ? score.averageTimeToHit
                          : "-"}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          {score.settings.reachDirection &&
            score.settings.reachDirection != "undefined" &&
            score.settings.reachDirection !== null && (
              <div className="table-heading-wrap">
                <h3>Hand-Specific Metrics</h3>
                <div className="assessment-info-new-table training-table af-bp-table-cols table">
                  <table
                    className="table two-col table-col-{{ table.Columns.length }} table-border-0"
                    aria-describedby="Assessment-Info-Table"
                  >
                    <thead className="table-head">
                      <tr>
                        <th scope="col" className="fz-16 fw-700 text-left">
                          Measure
                        </th>
                        <th scope="col" className="fz-16 fw-700">
                          Value
                        </th>
                      </tr>
                    </thead>
                  </table>
                  {(score.settings.reachDirection === "Across, Outward" ||
                    score.settings.reachDirection === "Across Only") && (
                    <table
                      className="table three-col table-col-{{ table.Columns.length }} table-border-0"
                      aria-describedby="Assessment-Info-Table"
                    >
                      <thead className="table-head">
                        <tr>
                          <th scope="col" className="fz-16 fw-700 text-left">
                            Across
                          </th>
                          <th scope="col" className="fz-16 fw-700">
                            Left
                          </th>
                          <th scope="col" className="fz-16 fw-700">
                            Right
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="fz-14 fw-600 text-left">
                            <span>Hits</span>
                          </td>
                          <td className="fz-14 fw-600">
                            <span>
                              {Number.isNaN(score.leftHand.leftAcrossHit)
                                ? "-"
                                : formatNumber(score.leftHand.leftAcrossHit)}
                            </span>
                          </td>
                          <td className="fz-14 fw-600">
                            <span>
                              {Number.isNaN(score.rightHand.rightAcrossHit)
                                ? "-"
                                : formatNumber(score.rightHand.rightAcrossHit)}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td className="fz-14 fw-600 text-left">
                            <span>Misses</span>
                          </td>
                          <td className="fz-14 fw-600">
                            <span>
                              {Number.isNaN(score.leftHand.leftAcrossMissed)
                                ? "-"
                                : formatNumber(score.leftHand.leftAcrossMissed)}
                            </span>
                          </td>
                          <td className="fz-14 fw-600">
                            <span>
                              {Number.isNaN(score.rightHand.rightAcrossMissed)
                                ? "-"
                                : formatNumber(
                                    score.rightHand.rightAcrossMissed
                                  )}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td className="fz-14 fw-600 text-left">
                            <span>Avg Time (s)</span>
                          </td>
                          <td className="fz-14 fw-600">
                            <span>
                              {Number.isNaN(
                                score.leftHand.leftAcrossAvgTimeToHit
                              )
                                ? "-"
                                : formatNumber(
                                    score.leftHand.leftAcrossAvgTimeToHit
                                  )}
                            </span>
                          </td>
                          <td className="fz-14 fw-600">
                            <span>
                              {Number.isNaN(
                                score.rightHand.rightAcrossAvgTimeToHit
                              )
                                ? "-"
                                : formatNumber(
                                    score.rightHand.rightAcrossAvgTimeToHit
                                  )}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td className="fz-14 fw-600 text-left">
                            <span>Max Reach (in)</span>
                          </td>
                          <td className="fz-14 fw-600">
                            <span>
                              {Number.isNaN(score.leftHand.leftAcrossReachDist)
                                ? "-"
                                : formatNumber(
                                    score.leftHand.leftAcrossReachDist
                                  )}
                            </span>
                          </td>
                          <td className="fz-14 fw-600">
                            <span>
                              {Number.isNaN(
                                score.rightHand.rightAcrossReachDist
                              )
                                ? "-"
                                : formatNumber(
                                    score.rightHand.rightAcrossReachDist
                                  )}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  )}

                  {(score.settings.reachDirection === "Across, Outward" ||
                    score.settings.reachDirection === "Outward Only") && (
                    <table
                      className="table three-col table-col-{{ table.Columns.length }} table-border-0"
                      aria-describedby="Assessment-Info-Table"
                    >
                      <thead className="table-head">
                        <tr>
                          <th scope="col" className="fz-16 fw-700 text-left">
                            Outward
                          </th>
                          <th scope="col" className="fz-16 fw-700">
                            Left
                          </th>
                          <th scope="col" className="fz-16 fw-700">
                            Right
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="fz-14 fw-600 text-left">
                            <span>Hits</span>
                          </td>
                          <td className="fz-14 fw-600">
                            <span>
                              {Number.isNaN(score.leftHand.leftOutwardHit)
                                ? "-"
                                : formatNumber(score.leftHand.leftOutwardHit)}
                            </span>
                          </td>
                          <td className="fz-14 fw-600">
                            <span>
                              {Number.isNaN(score.rightHand.rightOutwardHit)
                                ? "-"
                                : formatNumber(score.rightHand.rightOutwardHit)}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td className="fz-14 fw-600 text-left">
                            <span>Misses</span>
                          </td>
                          <td className="fz-14 fw-600">
                            <span>
                              {Number.isNaN(score.leftHand.leftOutwardMissed)
                                ? "-"
                                : formatNumber(
                                    score.leftHand.leftOutwardMissed
                                  )}
                            </span>
                          </td>
                          <td className="fz-14 fw-600">
                            <span>
                              {Number.isNaN(score.rightHand.rightOutwardMissed)
                                ? "-"
                                : formatNumber(
                                    score.rightHand.rightOutwardMissed
                                  )}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td className="fz-14 fw-600 text-left">
                            <span>Average Time to Hit (s)</span>
                          </td>
                          <td className="fz-14 fw-600">
                            <span>
                              {Number.isNaN(
                                score.leftHand.leftOutwardAvgTimeToHit
                              )
                                ? "-"
                                : formatNumber(
                                    score.leftHand.leftOutwardAvgTimeToHit
                                  )}
                            </span>
                          </td>
                          <td className="fz-14 fw-600">
                            <span>
                              {Number.isNaN(
                                score.rightHand.rightOutwardAvgTimeToHit
                              )
                                ? "-"
                                : formatNumber(
                                    score.rightHand.rightOutwardAvgTimeToHit
                                  )}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td className="fz-14 fw-600 text-left">
                            <span>Max Reach (in)</span>
                          </td>
                          <td className="fz-14 fw-600">
                            <span>
                              {Number.isNaN(score.leftHand.leftOutwardReachDist)
                                ? "-"
                                : formatNumber(
                                    score.leftHand.leftOutwardReachDist
                                  )}
                            </span>
                          </td>
                          <td className="fz-14 fw-600">
                            <span>
                              {Number.isNaN(
                                score.rightHand.rightOutwardReachDist
                              )
                                ? "-"
                                : formatNumber(
                                    score.rightHand.rightOutwardReachDist
                                  )}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  )}
                </div>
              </div>
            )}
        </IonCol>
      </IonRow>
    </IonGrid>
  );
};

export default BalloonPopper_Test;
